import { useFormikContext, Field } from "formik";
import React from "react";

function AccountAssets() {
  const { errors, touched } = useFormikContext();

  return (
    <div>
 <h2 class="heading1">Savings and assets</h2>
<p>Provide details of any savings and assets you have.</p>
<p>Not all options will be relevant to you. Answer all relevant questions and provide as accurate information as possible.</p>
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="bankaccounts"><span>Bank accounts (including current accounts)</span></label>  
        <span class="inline pound-font">£</span>
 
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="bankaccounts" name="bankaccounts" class="input-width--300"/>
    </div>
</fieldset>   
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="postoffice"><span>Post Office</span></label>  
        <span class="inline pound-font">£</span>
      
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="postoffice" name="postoffice" class="input-width--300"/>
    </div>
</fieldset>   
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="isa"><span>ISAs</span></label>  
        <span class="inline pound-font">£</span>
        
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="isa" name="isa" class="input-width--300"/>
    </div>
</fieldset>   

<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="shares"><span>Shares</span></label>  
        <span class="inline pound-font">£</span>
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="shares" name="shares" class="input-width--300"/>
    </div>
</fieldset>   
<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="premiumbonds"><span>Premium Bonds</span></label>  
        <span class="inline pound-font">£</span>
      
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="premiumbonds" name="premiumbonds" class="input-width--300"/>
    </div>
</fieldset>   

<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="incomebonds"><span>Income Bonds</span></label>  
        <span class="inline pound-font">£</span>
   
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="incomebonds" name="incomebond" class="input-width--300"/>
    </div>
</fieldset>   

<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="nationalsavingscerts"><span>National Savings Certificates</span></label>  
        <span class="inline pound-font">£</span>
        
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="nationalsavingscerts" name="nationalsavingscerts" class="input-width--300"/>
    </div>
</fieldset>   

<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="buildingsociety"><span>Building society</span></label>  
        <span class="inline pound-font">£</span>  
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="buildingsociety" name="buildingsociety" class="input-width--300"/>
    </div>
</fieldset>   

<fieldset class="question-section">
    <div class="form__control form__input">
        <label class="heading3 mbottom-10" htmlFor="otheraccountsassets"><span>Other accounts and assets (total of)</span></label>  
        <span class="inline pound-font">£</span>
       
        <Field type="text" inputmode="numeric" pattern="(\d+(,)?\d?)*(.)?\d[0-9]{0,1}$" id="otheraccountsassets" name="otheraccountsassets" class="input-width--300"/>
    </div>
</fieldset> 

    </div>
  );
}
export default AccountAssets;